/**
 * Country reference data.
 *
 * Only the ISO 3166-1 alpha-2 codes are stored here; the display names come
 * from `Intl.DisplayNames`, which ships with both Node and every browser we
 * support. That keeps the bundle small and the names correctly localised
 * rather than frozen into a hand-maintained English table that drifts.
 */
/** ISO 3166-1 alpha-2, officially assigned codes. */
export const COUNTRY_CODES = ('AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ ' +
    'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR ' +
    'GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP ' +
    'KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ ' +
    'NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW ' +
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ ' +
    'UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW').split(' ');
const CODE_SET = new Set(COUNTRY_CODES);
/**
 * Shown at the top of the picker. These are where the great majority of
 * candidates for the Australian registration exams qualified, so putting them
 * first saves most users a long scroll. The full list follows.
 */
export const PRIORITY_COUNTRY_CODES = [
    'IN', 'PK', 'EG', 'NG', 'PH', 'BD', 'LK', 'NP', 'IR', 'IQ', 'JO', 'SY', 'MY', 'CN', 'GB', 'ZA', 'AU', 'NZ',
];
export function isCountryCode(value) {
    return CODE_SET.has(value.toUpperCase());
}
let displayNames;
/** Human-readable country name, falling back to the raw code. */
export function countryName(code) {
    const upper = code.toUpperCase();
    if (displayNames === undefined) {
        try {
            displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
        }
        catch {
            displayNames = null;
        }
    }
    return displayNames?.of(upper) ?? upper;
}
/** Codes sorted by display name, priority entries hoisted to the front. */
export function countryOptions() {
    const priority = new Set(PRIORITY_COUNTRY_CODES);
    const rest = COUNTRY_CODES.filter((c) => !priority.has(c))
        .map((code) => ({ code, name: countryName(code), priority: false }))
        .sort((a, b) => a.name.localeCompare(b.name));
    return [
        ...PRIORITY_COUNTRY_CODES.map((code) => ({ code, name: countryName(code), priority: true })),
        ...rest,
    ];
}
//# sourceMappingURL=countries.js.map